import { Img } from "components";
import StepsYourDetail from "./StepsYourDetail";
import StepsDeliveryAddress from "./StepsDeliveryAddress";
import StepsDeliveryDateTime from "./StepsDeliveryDateTime";
import RecipientFormThankYouPage from "pages/RecipientFormThankYou";
import { getGiftOrderData, updateGiftOrderData } from "../../../redux/reducers/giftOrderData";
import { useSelector, useDispatch } from "react-redux";
import * as CUSTOM from "../../../utils/helper/custom";

// ─── Top Stepper ────────────────────────────────────────────────────────────────
const TopStepper = ({ currentStep, onStepClick }) => {
  const steps = [
    { id: 1, label: "Account",    icon: "/images/person.svg"     },
    { id: 2, label: "Delivery",   icon: "/images/mapLocation.png" },
    { id: 3, label: "Date & Time",icon: "/images/dateTime.png"  },
  ];

  return (
    <div className="flex flex-row items-start justify-center w-full mb-6 px-2">
      {steps.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isActive    = currentStep === step.id;
        const isClickable = isCompleted; // only completed steps are clickable (go back)

        return (
          <div key={step.id} className="flex flex-row items-center flex-1 last:flex-none">

            {/* Circle + label */}
            <div
              className={`flex flex-col items-center gap-1.5 flex-shrink-0 ${isClickable ? "cursor-pointer" : "cursor-default"}`}
              onClick={() => isClickable && onStepClick(step.id)}
            >
              <div
                className={`flex h-11 w-11 items-center justify-center rounded-full transition-all duration-300
                  ${isCompleted
                    ? "bg-pink-800 shadow-md hover:opacity-80"
                    : isActive
                    ? "bg-pink-800 shadow-[0_0_0_4px_rgba(157,23,77,0.15)]"
                    : "bg-white-A700 shadow-bs6 border border-gray-200"
                  }`}
              >
                {isCompleted ? (
                  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="white" strokeWidth="2.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <Img
                    className={`h-5 w-5 ${isActive ? "brightness-0 invert" : "opacity-40"}`}
                    src={step.icon}
                    alt={step.label}
                  />
                )}
              </div>

              <span
                className={`text-xs font-nunitomedium whitespace-nowrap transition-colors
                  ${isActive ? "text-pink-800 font-[Unbounded]" : isCompleted ? "text-pink-800" : "text-gray-400"}`}
              >
                {step.label}
              </span>
            </div>

            {/* Connector */}
            {index < steps.length - 1 && (
              <div className="flex-1 mx-2 mb-5">
                <div
                  className={`h-0.5 w-full transition-all duration-500 font-[Unbounded] ${isCompleted ? "bg-pink-800" : "bg-gray-200"}`}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

const RecipientFormSteps = ({ orderDetails }) => {
  const orderData = useSelector(getGiftOrderData);
  const dispatch  = useDispatch();

  const handleStepClick = (stepId) => {
    if (stepId < orderData?.pageStep) {
      dispatch(updateGiftOrderData({ ...orderData, pageStep: stepId }));
    }
  };

  // ── Thank-you page (step 4) ──
  if (orderData?.pageStep === 4) {
    return (
      <div className="relative flex flex-col flex-1 w-full">
        <RecipientFormThankYouPage orderData={orderData} />
      </div>
    );
  }

  return (
    <div className="relative flex flex-col flex-1 w-full">

      {/* Top progress stepper */}
      <TopStepper
        currentStep={orderData?.pageStep || 1}
        onStepClick={handleStepClick}
      />

      {/* Active step card — only ONE card visible at a time */}
      <div
        className="bg-white-A700 rounded-2xl py-6 px-6 xs:px-4 w-full"
        style={{ boxShadow: "0px 4px 40px 0px rgba(0,0,0,0.06)" }}
      >
        {orderData?.pageStep === 1 && (
          <StepsYourDetail />
        )}

        {orderData?.pageStep === 2 && (
          <StepsDeliveryAddress orderDetails={orderDetails} />
        )}

        {orderData?.pageStep === 3 && (
          <StepsDeliveryDateTime orderDetails={orderDetails} />
        )}
      </div>

    </div>
  );
};

export default RecipientFormSteps;
